import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=dfe680d0&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe680d0",
  null
  
)

export default component.exports